const PREFIX = "krionex:custom-builder:draft:v1";
const ACTIVE_PREFIX = "krionex:custom-builder:active:v1";

function normalizeWallet(walletAddress) {
    return String(walletAddress || "anonymous")
        .trim()
        .toLowerCase();
}

function normalizeProjectId(projectId) {
    const clean = String(projectId || "default").trim();

    if (/^[A-Za-z0-9_-]{1,100}$/.test(clean)) {
        return clean;
    }

    return "default";
}

function makeKey(walletAddress, projectId) {
    return `${PREFIX}:${normalizeWallet(walletAddress)}:${normalizeProjectId(
        projectId,
    )}`;
}

function safeParse(value) {
    try {
        return JSON.parse(value);
    } catch {
        return null;
    }
}

export function saveDraft(walletAddress, projectId, data = {}) {
    if (typeof window === "undefined") return null;

    const key = makeKey(walletAddress, projectId);

    const existing = safeParse(window.localStorage.getItem(key)) || {};

    const payload = {
        ...existing,
        ...data,
        walletAddress: normalizeWallet(walletAddress),
        projectId: normalizeProjectId(projectId),
        updatedAt: new Date().toISOString(),
        createdAt: existing.createdAt || new Date().toISOString(),
    };

    window.localStorage.setItem(key, JSON.stringify(payload));

    return payload;
}

export function loadDraft(walletAddress, projectId) {
    if (typeof window === "undefined") return null;

    const key = makeKey(walletAddress, projectId);
    return safeParse(window.localStorage.getItem(key));
}

export function deleteDraft(walletAddress, projectId) {
    if (typeof window === "undefined") return false;

    const key = makeKey(walletAddress, projectId);
    window.localStorage.removeItem(key);

    return true;
}

export function listDrafts(walletAddress) {
    if (typeof window === "undefined") return [];

    const wallet = normalizeWallet(walletAddress);
    const prefix = `${PREFIX}:${wallet}:`;

    const drafts = [];

    for (let i = 0; i < window.localStorage.length; i += 1) {
        const key = window.localStorage.key(i);

        if (!key || !key.startsWith(prefix)) continue;

        const value = safeParse(window.localStorage.getItem(key));

        if (value) {
            drafts.push({
                key,
                ...value,
            });
        }
    }

    return drafts.sort((a, b) => {
        return String(b.updatedAt || "").localeCompare(String(a.updatedAt || ""));
    });
}

export function clearAllDraftsForWallet(walletAddress) {
    if (typeof window === "undefined") return 0;

    const wallet = normalizeWallet(walletAddress);
    const prefix = `${PREFIX}:${wallet}:`;

    const keys = [];

    for (let i = 0; i < window.localStorage.length; i += 1) {
        const key = window.localStorage.key(i);
        if (key && key.startsWith(prefix)) keys.push(key);
    }

    for (const key of keys) {
        window.localStorage.removeItem(key);
    }

    return keys.length;
}

export function setActiveDraft(walletAddress, projectId) {
    if (typeof window === "undefined") return null;

    const wallet = normalizeWallet(walletAddress);
    const cleanProjectId = normalizeProjectId(projectId);

    window.localStorage.setItem(`${ACTIVE_PREFIX}:${wallet}`, cleanProjectId);

    return cleanProjectId;
}

export function getActiveDraftId(walletAddress) {
    if (typeof window === "undefined") return "";

    const wallet = normalizeWallet(walletAddress);
    return window.localStorage.getItem(`${ACTIVE_PREFIX}:${wallet}`) || "";
}

export function clearActiveDraft(walletAddress) {
    if (typeof window === "undefined") return false;

    const wallet = normalizeWallet(walletAddress);
    window.localStorage.removeItem(`${ACTIVE_PREFIX}:${wallet}`);

    return true;
}